/**
 * Panel Tab Constants
 * Enum values for side panel tabs in the application
 *
 * Usage:
 * import { PANEL_TAB, TAB_NAMES } from '@/constants/tabs';
 *
 * // Open tags panel
 * store.dispatch('SHOW_PANEL', { tabIndex: PANEL_TAB.TAGS, pinned: true });
 *
 * // Get tab name
 * const name = TAB_NAMES[PANEL_TAB.TAGS]; // 'Tags'
 */

export const PANEL_TAB = Object.freeze({
  SEARCH: 0,
  BOOKMARK: 1,
  PLANS_2D: 2,
  SCANS: 3,
  TAGS: 4,
  // Note: 5 is not used
  FILES: 6,
  DOCUMENTS: 7,
  // Note: 8 is not used
  SCAN_DOWNLOAD: 9,
  DISPLAY_SETTINGS: 10,
  INSPECTION: 11,
  AREAS: 12,
  MODELS: 13,
});

export const TAB_NAMES = Object.freeze({
  [PANEL_TAB.SEARCH]: 'Search',
  [PANEL_TAB.BOOKMARK]: 'Saved Views',
  [PANEL_TAB.PLANS_2D]: '2D Plans',
  [PANEL_TAB.SCANS]: 'Scans',
  [PANEL_TAB.TAGS]: 'Tags',
  [PANEL_TAB.FILES]: 'Files',
  [PANEL_TAB.DOCUMENTS]: 'Documents',
  [PANEL_TAB.SCAN_DOWNLOAD]: 'Scan Download',
  [PANEL_TAB.DISPLAY_SETTINGS]: 'Display Settings',
  [PANEL_TAB.INSPECTION]: 'Inspection',
  [PANEL_TAB.AREAS]: 'Areas',
  [PANEL_TAB.MODELS]: 'Models',
});

/**
 * Tag Info Panel Tab Indices
 * Used by all tag info components for the Info/Documents/Tasks tabs.
 *
 * Usage:
 * import { TAG_INFO_TAB } from '@/constants/tabs';
 * data() { return { tab: TAG_INFO_TAB.INFO } }
 */
export const TAG_INFO_TAB = Object.freeze({
  INFO: 0,
  DOCUMENTS: 1,
  TASKS: 2,
  MONITORING: 3,
  RECORDS: 4,
  /** AVA Inspect only: polygon snaps taken on 360 images. */
  SNAPS: 5,
  /** AVA Inspect only: AI findings of the tag's analysis runs. */
  FINDINGS: 6,
});

/**
 * Check if a tab index is valid
 * @param {number} tabIndex - Tab index to check
 * @returns {boolean} True if valid tab index
 */
export function isValidTab(tabIndex) {
  return Object.values(PANEL_TAB).includes(tabIndex);
}

/**
 * Get tab name by index
 * @param {number} tabIndex - Tab index
 * @returns {string} Tab name or empty string if not found
 */
export function getTabName(tabIndex) {
  return TAB_NAMES[tabIndex] || '';
}
